<template>
  <div class="search-results">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-11 offset-lg-1">
          <div class="search-results__title">Veja Sua Colocação na Corrida</div>
        </div>
        <div class="col-12 col-lg-7 offset-lg-1">
          <Input v-model="funcional" label="Insira seu Código funcional" color="#fff" />
        </div>
        <div class="col-12 col-lg-4 align-self-end">
          <Button @click="load" class="search-results__button" big>Enviar</Button>
        </div>
        <div v-if="error" class="col-12 col-lg-11 offset-lg-1">
          <Alert error>Esta funcional não está presente na lista de participantes</Alert>
        </div>
        <div v-if="result" class="col-12 col-lg-11 offset-lg-1">
          <template v-if="['DFEM','DMASC','DMISTA'].indexOf(result.TIPO) >= 0">
            <div class="search-results__competitor">{{ result.NOME.split('/')[0] }}</div>
            <div class="search-results__competitor">{{ result.NOME.split('/')[1] }}</div>
          </template>
          <template v-else>
            <div class="search-results__competitor">{{ result.NOME }}</div>
          </template>
          <div class="search-results__modality">Modalidade: {{ modalidades[result.TIPO] }}</div>
        </div>
      </div>
      <div v-if="result" class="search-results__result row">
        <div class="col-auto offset-lg-1">
          <img src="@/icons/trofeu.svg" alt="">
        </div>
        <div class="col">
          <div class="search-results__subtitle">Sua colocação geral foi</div>
          <div class="search-results__text">{{ result.COL_MF }}º</div>
        </div>
      </div>
      <div v-if="result" class="search-results__result row">
        <div class="col-auto offset-lg-1">
          <img src="@/icons/clock.svg" alt="">
        </div>
        <div class="col">
          <div class="search-results__subtitle">Tempo:</div>
          <div class="search-results__text">{{ result.TEMPO_BRUTO }}</div>
          <div class="search-results__subtitle">Tempo Líquido: {{ result.TEMPO_LIQ }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/services/api'
  import Input from '@/components/Input'
  import Button from '@/components/Button'
  import Alert from '@/components/Alert'

  export default {
    components: {
      Input,
      Button,
      Alert
    },
    data: () => ({
      error: null,
      funcional: '',
      result: null,
      modalidades: {
        M5: 'Corrida Individual Masculina 5km',
        F5: 'Corrida Individual Feminina 5km',
        DFEM: 'Revezamento Duplo Feminino 5km',
        DMASC: 'Revezamento Duplo Masculino 5km',
        DMISTA: 'Revezamento Duplo Misto 5km',
      }
    }),
    methods: {
      async load() {
        this.result = null

        this.error = null
        try {
          let { data: result } = await api.result(this.funcional)

          this.result = result

        } catch (error) {
          this.error = error
        }
      }
    }
  }
</script>

<style lang="scss">
 .search-results
 {
    background-color: #253044;
    padding: 140px 0;

    &__title
    {
      font-size: 50px;
      font-weight: bold;
      color: #fff;
      margin: 20px 0;
    }

    &__button
    {
      margin-bottom: 60px;
    }

    &__result
    {
      padding: 25px 0;
    }

    &__competitor
    {
      font-size: 40px;
      font-weight: bold;
      color: #fff;
      padding-left: 52px;
      background-image: url('../icons/runner.svg');
      background-repeat: no-repeat;
      background-position: top left;
      background-size: auto 40px;
    }

    &__modality
    {
      font-size: 25px;
      font-weight: 300;
      color: #fff;
      line-height: 40px;
      padding-left: 52px;
      margin-bottom: 40px;
    }

    &__subtitle
    {
      font-size: 30px;
      font-weight: 300;
      color: #fff;
    }

    &__text
    {
      font-size: 95px;
      font-weight: 800;
      color: #fff;

      @media (max-width: 991px)
      {
        font-size: 60px;
      }
    }
 }
</style>
